import React from "react";

export default function Experience() {
  const experiences = [
    {
      company: "Baker Tilly US, LLP",
      position: "Senior Consultant – Applications Development",
      location: "Chicago, IL (Remote)",
      period: "April 2022 – Present",
      description: "Deliver custom .NET applications end to end for enterprise clients — requirements gathering, architecture, development, deployment, and handoff — consistently within scope and budget.",
      highlights: [
        "Architect cloud-native solutions on Azure using ASP.NET Core, Entity Framework Core, and Blazor, including secure authentication with ASP.NET Core Identity and integration with client systems through RESTful APIs",
        "Serve as the technical point of contact across engagements, translating business requirements into technical specifications and explaining architectural tradeoffs to non-technical stakeholders",
        "Build reporting solutions in Power BI and Power Query that give business users direct visibility into operational data without developer involvement",
        "Adopt unfamiliar technologies on short timelines when client requirements call for them, delivering production-ready work in stacks outside the core practice",
        "Author solution documentation and lead client training sessions, equipping client teams to operate and maintain delivered systems independently",
        "Deploy and maintain applications across Azure and AWS, managing build and release pipelines in Azure DevOps"
      ],
      skills: ["Azure", "AWS", "Azure DevOps", "C#", "ASP.NET Core", "Blazor", "Entity Framework Core", "ASP.NET Core Identity", "REST APIs", "MS SQL Server", "Power BI", "Power Query", "DAX"],
      current: true
    },
    {
      company: "CBE Companies",
      position: "Software Developer I",
      location: "Cedar Falls, IA (Remote from 2021)",
      period: "May 2019 – June 2022",
      description: "Developed, optimized, and deployed front-end and full-stack features for production business applications used daily by internal teams and clients.",
      highlights: [
        "Modernized legacy VB.NET code toward C# and .NET, improving maintainability and reducing long-term support burden",
        "Built and maintained Blazor, MVC, and Telerik UI interfaces backed by Entity Framework and Microsoft SQL Server",
        "Diagnosed and resolved production defects, coordinating fixes through to release",
        "Partnered with QA on test coverage, release validation, and deployments, working within established SDLC and coding standards"
      ],
      skills: ["C#", "VB.NET", ".NET Framework", "Blazor", "MVC", "Telerik UI", "Entity Framework", "MS SQL Server", "Azure DevOps"],
      current: false
    },
    {
      company: "Scientific Games",
      position: "Software Engineering Intern",
      location: "Cedar Falls, IA",
      period: "June 2018 – August 2018",
      description: "Worked alongside a team of senior engineers on shipped mobile software built in Unity.",
      highlights: [
        "Improved mobile application performance in Unity by auditing and removing unused code, assets, and asset bundles",
        "Contributed C# features to shipped mobile software alongside a team of senior engineers"
      ],
      skills: ["C#", "Unity Game Engine"],
      current: false
    }
  ];

  return (
    <div className="mx-auto max-w-page px-5 py-16 md:px-10 md:py-24">
      <div className="flex items-baseline justify-between gap-6 border-b border-paper/30 pb-4">
        <h2 className="display font-serif text-4xl font-semibold tracking-tight md:text-6xl">
          Work
        </h2>
        <p className="label text-paper/60">01 / Experience</p>
      </div>

      <ol>
        {experiences.map((exp) => (
          <li
            key={exp.company}
            className="grid gap-6 border-b border-paper/30 py-10 md:grid-cols-12 md:gap-8 md:py-14"
          >
            <div className="md:col-span-3">
              <p className="label text-paper/80">
                {exp.current && (
                  <span className="mr-2 inline-block h-2 w-2 bg-vermilion align-middle" aria-hidden="true" />
                )}
                {exp.period}
              </p>
              <p className="label mt-2 text-paper/50">{exp.location}</p>
            </div>

            <div className="md:col-span-9">
              <h3 className={`font-serif font-semibold leading-tight tracking-tight ${exp.current ? "text-3xl md:text-5xl" : "text-2xl md:text-3xl"}`}>
                {exp.company}
              </h3>
              <p className="mt-1 font-serif text-lg italic text-paper/80 md:text-xl">
                {exp.position}
              </p>
              <p className="mt-5 max-w-3xl text-lg leading-relaxed">
                {exp.description}
              </p>

              <ul className={`mt-6 grid gap-x-10 gap-y-3 text-[0.95rem] leading-relaxed text-paper/80 ${exp.highlights.length > 3 ? "lg:grid-cols-2" : ""}`}>
                {exp.highlights.map((highlight, idx) => (
                  <li key={idx} className="grid grid-cols-[1.75rem_1fr]">
                    <span className="font-mono text-xs leading-7 text-vermilion">
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <span>{highlight}</span>
                  </li>
                ))}
              </ul>

              <p className="mt-6 font-mono text-xs leading-relaxed text-paper/60">
                <span className="text-paper/90">Stack: </span>
                {exp.skills.join(", ")}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
